import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[libCustomPageDirective]',
    standalone: false
})
export class CustomPageDirectiveDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
